import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mpp-hipaa-load-error-dialog',
  templateUrl: './hipaa-load-error-dialog.component.html',
  styleUrls: ['./hipaa-load-error-dialog.component.scss'],
  standalone: false,
})
export class HipaaLoadErrorDialogComponent {
  constructor(public dialogRef: MatDialogRef<HipaaLoadErrorDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
